import { Col, Row } from "react-bootstrap";

export const ContactInfo = () => {
    return (
        <Row className="justify-content-center">
            <Col sm={12} lg={10}>
                <div id="contact" className="contact-info-bx slideInUp text-start">
                    <Row>
                        <Col lg={12} md={6} xl={5}>
                            <h5>Mijn contact gegevens:</h5>
                        </Col>
                        <Col md={12} xl={7} className="text-end text-xl-start">
                            <p className="mt-1">
                                <a className="text-black hover:text-primary" href="mailto:jennifer.coenraad@icloud.com">
                                    jennifer.coenraad@icloud.com
                                </a>
                            </p>
                            <p>Hogeschool Utrecht - Heidelberglaan 15</p>
                        </Col>
                    </Row>
                </div>
            </Col>
        </Row>
    );
};
